import { Grid, styled } from '@mui/material';

export const FormContainer = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(8),
  flexDirection: 'column',
}));

export const Form = styled('form')(({ theme }) => ({
  width: '100%',
  maxWidth: 600,
  boxSizing: 'border-box',
  padding: theme.spacing(3),
  '& h2': {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  '& .scar-textField': {
    marginBottom: theme.spacing(2),
  },
}));

export const ButtonStyled = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const LinkContainer = styled('div')({
  textAlign: 'center',
  marginTop: 20,
});

export const LinkStyled = styled('a')({
  fontSize: '0.8em',
  fontWeight: 'bold',
  letterSpacing: 1,
});

export const StyledGridContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  minHeight: '100%',
}));

export const StyledFormContainer = styled(Grid)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  padding: theme.spacing(8),
  width: '100%',
}));

interface StyledGridItemProps {
  isLoading?: boolean;
}

export const StyledGridItem = styled(Grid, {
  shouldForwardProp: prop => prop !== 'isLoading',
})<StyledGridItemProps>(({ theme, isLoading = false }) => ({
  display: isLoading ? 'none' : 'flex',
  width: '100%',

  [theme.breakpoints.up('lg')]: {
    width: '50%',
  },
}));
